<template>
  <div>
    <span v-if="number" class="caption">Showing {{ number }} result.</span>
    <span v-else class="caption">No result.</span>
  </div>
</template>

<script>
  export default {
    name: "ResultNumber",

    props: {
      number: { type:Number, default: 0 }
    }
  }
</script>

<style lang="scss" scoped>

</style>